import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AttributeI } from '~src/interfaces/attributes.types';
import { translateContent } from '~src/services/translationServices';
import TableNavigator from '~src/modules/heatmap/components/table/TableNavigator';

import { DescriptionWrapper, EntityTitle, TableHeader, TopicQuestionTitle } from './columnDescription.sc';

interface Props {
  selectedAttributeObj: AttributeI | null;
  selectedSurveyName: string;
  scrollOn: (direction: 'forward' | 'back') => void;
}

const ColumnDescription: FC<Props> = ({ scrollOn, selectedAttributeObj, selectedSurveyName }) => {
  const [t] = useTranslation();
  const attrName = selectedAttributeObj ? translateContent(selectedAttributeObj.name) : '';
  return (
    <DescriptionWrapper>
      <EntityTitle data-translation="x.compare.table.entity_column.title">
        {t('x.compare.table.entity_column.title', { attr: attrName })}
      </EntityTitle>
      <TableHeader>
        <TopicQuestionTitle data-translation="x.compare.table.inner.title">
          {t('x.compare.table.inner.title', { name: selectedSurveyName })}
        </TopicQuestionTitle>
        <TableNavigator scrollOn={scrollOn} />
      </TableHeader>
    </DescriptionWrapper>
  );
};

export default ColumnDescription;
